import { render, staticRenderFns } from "./WebstoreApiTokenForm.vue?vue&type=template&id=1d40fe0c&scoped=true&"
import script from "./WebstoreApiTokenForm.vue?vue&type=script&lang=ts&"
export * from "./WebstoreApiTokenForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d40fe0c",
  null
  
)

export default component.exports